import './_lazy-dynamic-import-loader.scss'

function LazyDynamicImportLoader() {
  return (
    <div className="lazy-dynamic-import-loader" />
  )
}

export default LazyDynamicImportLoader;